import { render, staticRenderFns } from "./subTable2.vue?vue&type=template&id=ad2d8466&scoped=true&"
import script from "./subTable2.vue?vue&type=script&lang=js&"
export * from "./subTable2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2d8466",
  null
  
)

export default component.exports